import { defineNuxtPlugin } from '#app/nuxt';
import { useSystemFetch } from '#layers/base/public';
import { setSystemEntityStoreResolver } from '#layers/runtime/public';
import { createSystemRStore } from '~/rstore/create-system-rstore';

export default defineNuxtPlugin({
	name: 'system-entity-store',
	order: -21,
	async setup() {
		const store = await createSystemRStore(useSystemFetch());
		setSystemEntityStoreResolver(() => store);
	},
});
